var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "emailForm",
      attrs: {
        model: _vm.localValue,
        rules: _vm.emailFormRules,
        "label-width": "140px",
        autocomplete: "off"
      }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("from"), prop: "from" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "420px" },
              attrs: { disabled: !_vm.editable, filterable: "", size: "small" },
              on: { change: _vm.handleInput },
              model: {
                value: _vm.localValue.from,
                callback: function($$v) {
                  _vm.$set(_vm.localValue, "from", $$v)
                },
                expression: "localValue.from"
              }
            },
            _vm._l(_vm.emailAddressesFrom, function(address, index) {
              return _c(
                "el-option",
                {
                  key: index,
                  attrs: {
                    label: _vm.formatFromAddress(address),
                    value: address.email_from
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      }
                    },
                    [
                      _c("div", { staticStyle: { "font-size": "13px" } }, [
                        address.email_from_name
                          ? _c(
                              "span",
                              { staticStyle: { "font-weight": "600" } },
                              [_vm._v(_vm._s(address.email_from_name))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#8492a6",
                              "margin-left": "4px"
                            }
                          },
                          [_vm._v(_vm._s(address.email_from))]
                        )
                      ])
                    ]
                  )
                ]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("to"), prop: "to" } },
        [
          _c("el-input", {
            staticClass: "hidden-input",
            attrs: { tabindex: "-1", autocomplete: "new-password" },
            model: {
              value: _vm.localValue.to,
              callback: function($$v) {
                _vm.$set(_vm.localValue, "to", $$v)
              },
              expression: "localValue.to"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tag-input-container",
              class: { focused: _vm.toInputFocused, disabled: !_vm.editable },
              on: { click: _vm.focusToInput }
            },
            [
              _c(
                "div",
                { staticClass: "tags-and-input" },
                [
                  _vm._l(_vm.toTags, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: "to-" + index,
                        staticClass: "input-tag",
                        attrs: {
                          size: "small",
                          closable: "",
                          "disable-transitions": false
                        },
                        on: {
                          close: function($event) {
                            $event.stopPropagation()
                            return _vm.removeToTag(tag)
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t")]
                    )
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.toInputValue,
                        expression: "toInputValue"
                      }
                    ],
                    ref: "toInput",
                    staticClass: "tag-input",
                    staticStyle: { width: "420px" },
                    attrs: {
                      disabled: !_vm.editable,
                      type: "text",
                      autocomplete: "new-password"
                    },
                    domProps: { value: _vm.toInputValue },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("to")
                      },
                      blur: function($event) {
                        return _vm.handleBlur("to")
                      },
                      keydown: function($event) {
                        return _vm.handleTagInputKeydown($event, "to")
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) return
                          _vm.toInputValue = $event.target.value
                        },
                        function($event) {
                          return _vm.handleInput()
                        }
                      ]
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.endpointSuggestions.length > 0 && _vm.toInputFocused
                ? _c(
                    "div",
                    { staticClass: "suggestions-dropdown" },
                    _vm._l(_vm.endpointSuggestions, function(
                      suggestion,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: "to-suggestion-" + index,
                          staticClass: "suggestion-item",
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.selectSuggestion("to", suggestion)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(suggestion) + "\n\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.suggestedTo && _vm.suggestedTo.length > 0
            ? [
                _c("p", { staticClass: "input-help" }, [
                  _vm._v(
                    _vm._s(_vm.$t("suggested_to_lower")) +
                      ": " +
                      _vm._s(_vm.suggestedTo.join(", "))
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "input-help" }, [
            _vm._v(_vm._s(_vm.$t("action_detail.input-help.to")))
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("Cc"), prop: "cc" } },
        [
          _c("el-input", {
            staticClass: "hidden-input",
            attrs: { tabindex: "-1", autocomplete: "new-password" },
            model: {
              value: _vm.localValue.cc,
              callback: function($$v) {
                _vm.$set(_vm.localValue, "cc", $$v)
              },
              expression: "localValue.cc"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tag-input-container",
              class: { focused: _vm.ccInputFocused, disabled: !_vm.editable },
              on: { click: _vm.focusCcInput }
            },
            [
              _c(
                "div",
                { staticClass: "tags-and-input" },
                [
                  _vm._l(_vm.ccTags, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: "cc-" + index,
                        staticClass: "input-tag",
                        attrs: {
                          size: "small",
                          closable: "",
                          "disable-transitions": false
                        },
                        on: {
                          close: function($event) {
                            $event.stopPropagation()
                            return _vm.removeCcTag(tag)
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t")]
                    )
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ccInputValue,
                        expression: "ccInputValue"
                      }
                    ],
                    ref: "ccInput",
                    staticClass: "tag-input",
                    staticStyle: { width: "580px" },
                    attrs: {
                      disabled: !_vm.editable,
                      type: "text",
                      autocomplete: "new-password"
                    },
                    domProps: { value: _vm.ccInputValue },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("cc")
                      },
                      blur: function($event) {
                        return _vm.handleBlur("cc")
                      },
                      keydown: function($event) {
                        return _vm.handleTagInputKeydown($event, "cc")
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) return
                          _vm.ccInputValue = $event.target.value
                        },
                        function($event) {
                          return _vm.handleInput()
                        }
                      ]
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.endpointSuggestions.length > 0 && _vm.ccInputFocused
                ? _c(
                    "div",
                    { staticClass: "suggestions-dropdown" },
                    _vm._l(_vm.endpointSuggestions, function(
                      suggestion,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: "cc-suggestion-" + index,
                          staticClass: "suggestion-item",
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.selectSuggestion("cc", suggestion)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(suggestion) + "\n\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "input-help" }, [
            _vm._v(_vm._s(_vm.$t("action_detail.input-help.cc")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("bcc"), prop: "bcc" } },
        [
          _c("el-input", {
            staticClass: "hidden-input",
            attrs: { tabindex: "-1", autocomplete: "new-password" },
            model: {
              value: _vm.localValue.bcc,
              callback: function($$v) {
                _vm.$set(_vm.localValue, "bcc", $$v)
              },
              expression: "localValue.bcc"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tag-input-container",
              class: { focused: _vm.bccInputFocused, disabled: !_vm.editable },
              on: { click: _vm.focusBccInput }
            },
            [
              _c(
                "div",
                { staticClass: "tags-and-input" },
                [
                  _vm._l(_vm.bccTags, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: "bcc-" + index,
                        staticClass: "input-tag",
                        attrs: {
                          size: "small",
                          closable: "",
                          "disable-transitions": false
                        },
                        on: {
                          close: function($event) {
                            $event.stopPropagation()
                            return _vm.removeBccTag(tag)
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t")]
                    )
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.bccInputValue,
                        expression: "bccInputValue"
                      }
                    ],
                    ref: "bccInput",
                    staticClass: "tag-input",
                    staticStyle: { width: "580px" },
                    attrs: {
                      disabled: !_vm.editable,
                      type: "text",
                      autocomplete: "new-password"
                    },
                    domProps: { value: _vm.bccInputValue },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("bcc")
                      },
                      blur: function($event) {
                        return _vm.handleBlur("bcc")
                      },
                      keydown: function($event) {
                        return _vm.handleTagInputKeydown($event, "bcc")
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) return
                          _vm.bccInputValue = $event.target.value
                        },
                        function($event) {
                          return _vm.handleInput()
                        }
                      ]
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.endpointSuggestions.length > 0 && _vm.bccInputFocused
                ? _c(
                    "div",
                    { staticClass: "suggestions-dropdown" },
                    _vm._l(_vm.endpointSuggestions, function(
                      suggestion,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: "bcc-suggestion-" + index,
                          staticClass: "suggestion-item",
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.selectSuggestion("bcc", suggestion)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(suggestion) + "\n\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "input-help" }, [
            _vm._v(_vm._s(_vm.$t("action_detail.input-help.cc")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("subject"), prop: "subject" } },
        [
          _c("el-input", {
            staticClass: "hidden-input",
            attrs: { tabindex: "-1", autocomplete: "new-password" },
            model: {
              value: _vm.localValue.subject,
              callback: function($$v) {
                _vm.$set(_vm.localValue, "subject", $$v)
              },
              expression: "localValue.subject"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "subject-input-container",
              class: {
                focused: _vm.subjectInputFocused,
                disabled: !_vm.editable
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localValue.subject,
                    expression: "localValue.subject"
                  }
                ],
                ref: "subjectInput",
                staticClass: "subject-input",
                attrs: {
                  disabled: !_vm.editable,
                  type: "text",
                  autocomplete: "new-password"
                },
                domProps: { value: _vm.localValue.subject },
                on: {
                  focus: function($event) {
                    _vm.subjectInputFocused = true
                  },
                  blur: function($event) {
                    _vm.subjectInputFocused = false
                  },
                  input: [
                    function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.localValue, "subject", $event.target.value)
                    },
                    function($event) {
                      return _vm.handleInput()
                    }
                  ]
                }
              })
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }